const TAB_SIZE = 2;
export const printRowOffset = (level: number) => " ".repeat(level * TAB_SIZE);
